// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { Tooltip } from '../../model/tooltip';

@Component({
  selector: 'coa-spy-line-chart-tooltip',
  templateUrl: './spy-line-chart-tooltip.component.html',
  styleUrls: ['./spy-line-chart-tooltip.component.scss'],
})
export class SpyLineChartTooltipComponent {
  @Input() label: string;
  @Input() tooltip: Tooltip;

}
